import { render } from "./App.vue?vue&type=template&id=0a36050e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0a36050e&lang=scss"

import exportComponent from "C:\\Users\\bert\\Documents\\Projects\\eurolimo-drivers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__